import { useEffect } from 'react'

import { useAiChat } from '@factorialco/f0-react/dist/experimental'

type UseAutoOpenChatParams = {
  shouldAutoOpen?: boolean
}

export const useAutoOpenChat = (
  { shouldAutoOpen }: UseAutoOpenChatParams = { shouldAutoOpen: true }
) => {
  const { open, setOpen } = useAiChat()

  useEffect(() => {
    if (!shouldAutoOpen) return

    const initiallyOpen = open

    if (!initiallyOpen) {
      setOpen(true)
    }

    return () => {
      if (!initiallyOpen) {
        setOpen(false)
      }
    }
  }, [shouldAutoOpen])
}
